import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgShop({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.913 9l.885 9.728A3 3 0 0118.81 22H5.19a3 3 0 01-2.987-3.272L3.087 9h17.826zm-1.826 2H4.913l-.719 7.91A.998.998 0 005.19 20h13.62a1 1 0 00.996-1.09l-.72-7.91zM12 2a6.002 6.002 0 015.88 4.804 1 1 0 01-1.96.397 4.002 4.002 0 00-7.84 0 1 1 0 01-1.96-.398A6.002 6.002 0 0112 2z"
        fill={color}
      />
    </svg>
  )
}

export default SvgShop
